import { Injectable } from '@angular/core';


@Injectable({
  providedIn: 'root',
})
export class UtilsService {
  constructor() {
  }

  secondsToTime(seconds: number): string {
    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);
    const formattedHours = hours.toString().padStart(2, '0');
    const formattedMinutes = minutes.toString().padStart(2, '0');

    return `${formattedHours}:${formattedMinutes}`;
  }

  getMillisecondsOfCurrentDay(): number {
    const now = new Date(); 
    const startOfDay = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    const millisecondsOfCurrentDay = now.getTime() - startOfDay.getTime();

    return millisecondsOfCurrentDay;
  }

  getTodayDate(): string {
    const today = new Date();

    const year = today.getFullYear();
    const month = (today.getMonth() + 1).toString().padStart(2, '0'); 
    const day = today.getDate().toString().padStart(2, '0');

    return `${year}${month}${day}`;
  }

  getTomorrowDate(): string {
    const today = new Date();
    today.setDate(today.getDate() + 1)

    const year = today.getFullYear();
    const month = (today.getMonth() + 1).toString().padStart(2, '0'); 
    const day = today.getDate().toString().padStart(2, '0');

    return `${year}${month}${day}`;
  }

  formatDate(date: Date): string {
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, '0'); 
    const day = date.getDate().toString().padStart(2, '0');

    return `${year}${month}${day}`;
  }

  getDateForSearch(date: Date): string {
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, '0'); 
    const day = date.getDate().toString().padStart(2, '0');

    return `${year}-${month}-${day}`;
  }

  maskPhoneNumber(phone: string): string {
    const clean = phone.replace(/\s/g, '');

    if (clean.startsWith('+351')) {
      const ptRegex = /^(\+351)(\d{2})\d\d{3}\d(\d{2})$/;
      
      return clean.replace(ptRegex, '$1 $2* *** *$3');
    }

    const genericRegex = /^(\+\d{5})(.*)(\d{1})$/;
    return clean.replace(genericRegex, (_, g1, g2, g3) => {
      return `${g1}${ '*'.repeat(g2.length) }${g3}`;
    });
  }

  maskEmail(email: string): string {
    const [username, domain] = email.split("@");

    if (!username || !domain) return email; // Return original if invalid

    if (username.length <= 2) {
      return `${username[0]}***@${domain}`;
    }

    const maskedUsername = username.substring(0, 2) + "*".repeat(username.length - 2);
    
    return `${maskedUsername}@${domain}`;
  }

  maskVat(vat: string): string {
    if(vat == undefined || vat.length != 9) return vat;
    
    const regex = /^(\d{2})(\d{5})(\d{2})$/;

    return vat.replace(regex, '$1* *** *$3');
  }

  addWorkDays(startDate: Date, daysToAdd: number): Date {
    const date = new Date(startDate);
    let addedDays = 0;

    while (addedDays < daysToAdd) {
      date.setDate(date.getDate() + 1);
      const day = date.getDay();
      if (day !== 0 && day !== 6) {
        addedDays++;
      }
    }
    return date;
  }

  getWorkingHours(startDate: Date, endDate: Date): number {
    let count = 0;
    const current = new Date(startDate);

    // Iterate hour by hour
    while (current < endDate) {
      const dayOfWeek = current.getDay();
      const isWeekend = (dayOfWeek === 0 || dayOfWeek === 6); // 0=Sun, 6=Sat

      if (!isWeekend) {
        count++;
      }
      
      current.setHours(current.getHours() + 1);
    }
    return count;
  }
}
